import { Observable } from "rxjs";
import { BaseResponseModel } from "../models/base-response.model";
import { COMMON_SERVICE, CommonInterface } from "./common.interface";
import { Inject, Injectable } from "@angular/core";
import { API } from "../constants";
import { HttpParams } from "@angular/common/http";
import { HttpService } from "./http.service";
import { NotificationSearchModel } from "../models";
import { HTTP_SERVICE } from "./http.interface";

@Injectable()

export class CommonService implements CommonInterface {

  constructor(
    @Inject(HTTP_SERVICE) private _httpService: HttpService
  ) { }

  getStoreList(): Observable<BaseResponseModel<any>> {
    return this._httpService.get(API.GET_STORES_LIST);
  }
  getCountryList(): Observable<BaseResponseModel<any>> {
    return this._httpService.get(API.GET_COUNTRY_LIST);
  }
  getStateList(countryId: string): Observable<BaseResponseModel<any>> {
    let params = new HttpParams();
    params = params.set("countryId", countryId)
    return this._httpService.get(API.GET_STATE_LIST, params);
  }

  changeFormatUtcToIst<T>(
    formatedData: BaseResponseModel<T>
  ): BaseResponseModel<T> {
    return formatedData.data.map(item => ({
      ...item,
      fromDate: item.fromDate
        ? new Date(new Date(item.fromDate).getTime() + 330 * 60000)
        : null,
      toDate: item.toDate
        ? new Date(new Date(item.toDate).getTime() + 330 * 60000)
        : null
    }));
  }

  changeFormatValidFromUtcToIst<T>(
    formatedData: BaseResponseModel<T>
  ): BaseResponseModel<T> {
    return formatedData.data.map(item => ({
      ...item,
      validFrom: item.validFrom
        ? new Date(new Date(item.validFrom).getTime() + 330 * 60000)
        : null,
      validTo: item.validTo
        ? new Date(new Date(item.validTo).getTime() + 330 * 60000)
        : null
    }));
  }

  notificationMarkAsRead(notificationId: number): Observable<BaseResponseModel<any>> {
    const body = { notificationId };
    return this._httpService.post(API.NOTIFICATION_MARK_AS_READ, body);
  }

  getNotificationList(searchModel: NotificationSearchModel): Observable<BaseResponseModel<any>> {
    let params = new HttpParams()
      .set('page', searchModel.page)
      .set('pageSize', searchModel.pageSize);
    if (searchModel.searchText) {
      params = params.set('searchText', searchModel.searchText);
    }
    return this._httpService.get(API.GET_NOTIFICATIONS_LIST, params);
  }

  getNotificationsUnreadCount(): Observable<BaseResponseModel<any>> {
    return this._httpService.get(API.GET_NOTIFICATIONS_UNREAD_COUNT);
  }
}
